import api from '../index'

export interface dashboardInfoAccountType {
  balance: string
  recharge_sum: string
  recharge_count: number
  recharge_pending_sum: string
  recharge_pending_count: number
}
export interface dashboardCardStatusType {
  normal: number
  canceling: number
  cancelled: number
  other: number
}
export interface dashboardCardBinListType {
  cardbin: number
  count: number
  cardScheme: string
}
export interface dashboardInfoType {
  account: dashboardInfoAccountType
  card: {
    card_count: number
    card_status: dashboardCardStatusType
    cardbin_list: Array<dashboardCardBinListType>
  }
}
export default {
  // index数据
  info: () => api.get<dashboardInfoType>('member-api/dashboard', {
    params: {
      _action: 'getData',
    },
  }),
  // 获取资金趋势数据
  financialTrends: (data: {
    type: 'year' | 'month' | 'week'
  }) => api.get<{
    xdata: Array<string>
    ydata: Array<{
      i18n_key: string
      data: Array<string | number>
      color: string
    }>
  }>('member-api/dashboard', {
    params: {
      _action: 'moneyTree',
      type: data.type,
    },
  }),
}
